module.exports = __webpack_public_path__ + "img/001-wind-13.bd5ab26c.svg";